module.exports = __webpack_public_path__ + "static/media/c++Logo.9b6d177b.png";